import React, { Component } from "react";
import Pagination from "../../../Components/Pagination";
import TripsTable from './TripsTable';

const tripsData = [
    {
        no: "NS001-110619",
        id:12345,
        date: 1560983073054,
        route: {
            from: "Cairo",
            to: "Alex"
        },
        time: {
            departure: "03:00 PM",
            return: null
        },
        bookings: 3,
    },
    {
        no: "NS002-110619",
        id:22345,
        date: 1560983073054,
        route: {
            from: "Cairo",
            to: "Alex"
        },
        time: {
            departure: "03:00 PM",
            return: "09:00 PM"
        },
        bookings: 3,
    },
    {
        no: "NS003-110619",
        id:32345,
        date: 1560983073054,
        route: {
            from: "Cairo",
            to: "Alex"
        },
        time: {
            departure: "03:00 PM",
            return: "03:00 am"
        },
        bookings: 0,
    }
];

export default class ViewList extends Component {
    constructor(props) {
        super(props);
        this.state = {
          popupActive: null,
        };
    }
    componentWillMount() {
      document.addEventListener('keydown', e => {
        // console.log(e.keyCode);
        if (e.keyCode === 27) {
          this.props.toggleFn(e);
        }
      });
    }

    togglePopupClasses = (event, id) => {
        event.preventDefault();
        this.setState({ popupActive: this.state.popupActive !== id ? id : null });
      };

    render() {

        return (
            <React.Fragment>
                <div className="table-responsive">
                    <TripsTable tripsData={tripsData} toggleFn={this.togglePopupClasses}/>
                </div>
                <Pagination />
            </React.Fragment>
        );
    }
}
